<template>
  <div class="form-floating-field">
    <div class="form-floating">
      <input
        :value="localValue"
        @input="input($event)"
        :name="name"
        :type="type"
        required="required"
        class="form-floating__input"
      >
      <label class="form-floating__label">{{label}}</label>
    </div>
    <span
      v-if="hint"
      class="help-text is--warning"
    >{{hint}}</span>
  </div>
  <!-- :class="!$mobile ? 'is--warning' : 'text--deep-orange accent-4'" -->
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    type: { type: String, default: 'text' },
    value: { type: [String, Number] },
    error: { type: Object },
    name: { type: String, required: true }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  computed: {
    hint: function () {
      return (this.error && this.name && this.error.fieldId === this.name) ? this.error.errorMessage : ''
    }
  },
  watch: {
    value () {
      this.localValue = this.value
    }
  },
  methods: {
    input ($event) {
      this.localValue = $event.target.value

      this.$emit('input', this.type === 'inteter' ? Number(this.localValue) : this.localValue)
    }
  }
}
</script>
